import React from 'react';
import { SvgComplexIcon, SvgIconProps } from './SvgIcon';

const EgoSlice = (props: SvgIconProps) => (
  <SvgComplexIcon
    {...props}
    viewBox={[16, 16, 166, 166]}
    d="M134.39,65.51c-3.75-6.37-25.66-36.3-34.47-43.53-1.4-1.15-2.96-2.32-4.78-2.38-2.08-.07-4.03,1.18-5.46,2.69-12.64,13.35-26.21,32.04-33.52,43.82-9.82,15.82-19.02,33.8-19.02,52.89,0,31.94,25.91,59.85,57.85,59.85s57.85-27.91,57.85-59.85c0-19.11-8.96-37.39-18.46-53.5ZM89.78,164.38c-4.72,0-8.52-3.8-8.52-8.52s3.8-8.52,8.52-8.52c17.26,0,38.12-13.99,38.12-31.25,0-3.84,2.38-6.3,4.74-6.3,3.24,0,5.44,2.69,5.44,6.3,0,26.67-21.63,48.29-48.29,48.29Z"
  />
);

export default EgoSlice;
